import { render, staticRenderFns } from "./website-whois-detail.vue?vue&type=template&id=9f6f58b8&scoped=true&"
import script from "./website-whois-detail.vue?vue&type=script&lang=js&"
export * from "./website-whois-detail.vue?vue&type=script&lang=js&"
import style0 from "./website-whois-detail.vue?vue&type=style&index=0&id=9f6f58b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6f58b8",
  null
  
)

export default component.exports